import React, { useCallback, useEffect, useRef, useState } from 'react';
import classes from './EmptyDepot.module.scss';
import EntityBox from '../EntityBox/EntityBox';
import get from '../../../../services/axios/get';
import del from '../../../../services/axios/delete';
import patch from '../../../../services/axios/patch';
import { useAppDispatch } from '../../../../store/hooks';
import { customAlert } from '../../../../store/actions/alert';
import post from '../../../../services/axios/post';

interface DepoProps { };

const Depos: React.FC<DepoProps> = (props) => {
  const dispatch = useAppDispatch()
  const isMounted = useRef(true);
  const [depos, setDepos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isBroken, setIsBroken] = useState(false);

  const createNewDepo = (depot: { alias: string }) => {
    post(
      '/depot',
      { alias: depot.alias, isPlugin: false },
      () => {
        if (isMounted) {
          setIsLoading(true);
          getDepos();
        }
      },
      (err) => {
        if (isMounted) {
          dispatch(customAlert(true, err));
          setIsLoading(false);
          setIsBroken(true);
        }
      }
    )
  }

  const deleteDepo = (depoId: string) => {
    del(
      `/depot/${depoId}`,
      {},
      () => {
        if (isMounted) {
          setIsLoading(true);
          getDepos();
        }
      },
      (err) => {
        if (isMounted) {
          dispatch(customAlert(true, err));
          setIsLoading(false);
          setIsBroken(true);
        }
      }
    )
  };

  const editDepo = (depoId: string, depoName: string) => {
    patch(
      `/depot/${depoId}`,
      { alias: depoName },
      () => {
        if (isMounted) {
          setIsLoading(true);
          getDepos();
        }
      },
      (err) => {
        if (isMounted) {
          dispatch(customAlert(true, err));
          setIsLoading(false);
          setIsBroken(true);
        }
      }
    )
  };

  const getDepos = useCallback(
    () => {
      get(
        '/depot',
        { isPlugin: false },
        (res) => {
          if (isMounted) {
            setDepos(res.data);
            setIsLoading(false)
          }
        },
        () => {
          setIsBroken(true);
          setIsLoading(false)
        });
    },
    []
  );

  useEffect(() => {
    getDepos();

    return () => {
      isMounted.current = false;
    }
  }, [getDepos])

  return (
    <>
      <EntityBox
        entityName='empty depot'
        header='Empty Depots'
        isLoading={isLoading}
        entities={depos}
        isBroken={isBroken}
        delete={deleteDepo}
        edit={editDepo}
        createNewEntity={createNewDepo}
      />
    </>

  );
};

export default Depos;